import RadioButtonsComponent, {
  RadioButtonsComponentProps,
} from './RadioButtonsComponent';
export default RadioButtonsComponent;
export type { RadioButtonsComponentProps };
